import * as THREE from 'three'
import MSDFShader from 'three-bmfont-text/shaders/msdf'
import { Promise } from 'bluebird'
import loadFont from 'load-bmfont'
import { each, keys, set, isUndefined } from 'lodash'

import { getStaticPath } from './utils'

import fragmentShader from './shaders/fragment.glsl'
import vertexShader from './shaders/vertex.glsl'

Promise.config({ cancellation: true })

class Text {
  constructor() {
    this.update = this.update.bind(this)

    this.mesh = null
    this.geometry = null
    this.texture = null
  }

  loadFont(basePath = null) {
    const createGeometry = require('three-bmfont-text')

    const fn = 'ARRAYDIO6-Regular'
    const _basePath = getStaticPath('msdf/', basePath)

    return new Promise((resolve, reject, onCancel) => {
      loadFont(`${_basePath}${fn}.fnt`, (e, font) => {
        const loader = new THREE.TextureLoader()
        loader.load(`${_basePath}${fn}.png`, texture => {
          const geometry = createGeometry({
            font,
            align: 'center',
            text: 'arca - non-binary',
          })

          resolve(this.onFontLoaded(geometry, texture))
        })
      })
    })
  }

  onFontLoaded(geometry, texture) {
    const material = new THREE.RawShaderMaterial(
      MSDFShader({
        fragmentShader,
        vertexShader,
        map: texture,
        side: THREE.DoubleSide,
        transparent: true,
        negate: false,
        color: 0x000000,
      })
    )

    material.uniforms.playhead = {
      type: 'f',
      value: 0.0,
    }
    material.uniforms.textSize = {
      type: 'v2',
      value: new THREE.Vector2(geometry.layout.width, geometry.layout.height),
    }
    console.log(geometry.layout)
    material.uniforms.u_resolution = {
      type: 'v2',
      value: new THREE.Vector2(),
    }

    const mesh = new THREE.Mesh(geometry, material)

    this.mesh = mesh
    this.geometry = geometry
    this.texture = texture

    return {
      geometry,
      texture,
      mesh,
    }
  }

  update(props) {
    if (this.mesh) {
      each(keys(props), (_k, _i) => {
        //if(!isUndefined(get(this.mesh.material.uniforms, _k))){
        if (_k in this.mesh.material.uniforms) {
          const _v = props[_k]
          this.mesh.material.uniforms[_k].value = _v
        }
      })
      this.mesh.material.uniformsNeedUpdate = true
    }
    // console.log(props, this.mesh.material.uniforms)
  }
}

export default Text
